module.exports = {
  SHELL: "SHELL",
  ARGV: "ARGV"
};



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/MesosCommandTypes.js